export default "__VITE_ASSET__Kp5wH7K$__"